import ContactsService from 'services/onboarding/contacts/ContactsService';

export default {
	'services.onboardingContactsService': {
		class: ContactsService,
		deps: [{ $ref: 'services.APIService' }],
	},
};
